
import router from "@/router";
import { defineComponent, ref, watch } from "vue";
import { getProduct, listSimple, brandlist } from "@/api/Commodityallocation";
import moment from "moment";
export default defineComponent({
  name: "stock",
  setup() {
    // 表格数据
    const tableData = ref<any>();
    const tableColumn = ref([
      {
        prop: "name",
        label: "商品名称",
      },

      {
        slotName: "classImg",
      },
      {
        prop: "sku",
        label: "规格",
      },
      // {
      //   prop: "date",
      //   label: "销售价格",
      // },
      {
        prop: "code",
        label: "商品货号",
      },
      {
        prop: "typeName",
        label: "所属分类",
      },
      {
        prop: "brandName",
        label: "品牌",
      },
      // {
      //   slotName: "accounttype",
      // },
      {
        prop: "createTime",
        label: "添加时间",
      },
      {
        slotName: "slotName",
      },
    ]);
    // 分类下拉参数
    const listSimpleForm = ref<Req.listSimple>({
      parentId: 0,
      merchantId: 0,
    });
    // 三级下拉类别
    const listSimpleArr1 = ref<any>([]);
    const listSimpleArr2 = ref<any>([]);
    const listSimpleArr3 = ref<any>([]);
    // 商品列表参数
    const productForm = ref<any>({
      brandNo: "",
      code: "",
      endTime: "",
      erpName: "",
      erpSign: "",
      erpWarehouseId: "",
      firstGoodTypeId: "",
      isHot: "",
      isSale: "",
      isSerial: false,
      isStock: "",
      isSubscribe: "",
      merchantId: 0,
      name: "",
      onlineToOffline: "",
      pageNum: 1,
      pageSize: 10,
      sort: "",
      sortType: "",
      startTime: "",
      storeId: 0,
      threeGoodTypeId: "",
      twoGoodTypeId: "",
      typeId: "",
    });
    const getProductTable = () => {
      // 获取表格数据
      getProduct(productForm.value).then((res) => {
        tableData.value = res.data;
        console.log(tableData.value.list);
      });
    };
    watch(
      () => tableData.value,
      () => {
        console.log(tableData.value);
      }
    );
    // 联动分类
    const getMyClass = (key?: any) => {
      // 获取一级下拉
      listSimple(listSimpleForm.value).then((res) => {
        // 第一级获得二级
        if (key == 1) {
          listSimpleArr2.value = res.data;
          // 点二级获得三级
        } else if (key == 2) {
          listSimpleArr3.value = res.data;
        } else if (key == 3) {
          return;
        } else {
          listSimpleArr1.value = res.data;
        }
      });
    };
    const Getclass = (arr: any, arr2: Res.listSimple | Res.brandlist, name?: string) => {
      arr.forEach((item: any) => {
        if (item.key == name) {
          item.optionList = arr2;
        }
      });
    };
    // 商品品牌下拉
    const brandlistData = ref([] as any);
    // 获取品牌下拉
    const getbrandlist = () => {
      brandlist({ baseDto: { pageNum: 1, pageSize: 999999 } }).then((res) => {
        brandlistData.value = res.data.data;
        // console.log(brandlistData.value)
        Getclass(state.value.formList, brandlistData.value, "brandNo");
      });
    };
    getbrandlist();
    getMyClass();
    getProductTable();
    // 头部查询
    const state = ref({
      formList: [
        {
          label: "商品名称",
          key: "name",
          type: "input",
          placeholder: "请输入商品名称",
          clearable: true,
        },
        {
          label: "商品货号",
          key: "code",
          type: "input",
          placeholder: "请输入商品货号",
          clearable: true,
        },
        // {
        //   label: "选择分类",
        //   key: "typeId",
        //   type: "select",
        //   placeholder: "请选择一级分类",
        //   clearable: true,
        //   optionList: listSimpleArr1.value,
        // },
        // {
        //   key: "twoGoodTypeId",
        //   type: "select",
        //   placeholder: "请选择二级分类",
        //   clearable: true,
        //   optionList: listSimpleArr2.value,
        // },
        // {
        //   key: "threeGoodTypeId",
        //   type: "select",
        //   placeholder: "请选择三级分类",
        //   clearable: true,
        //   optionList: listSimpleArr3.value,
        // },
        {
          slotName: "selectThree",
        },
        {
          label: "添加时间",
          key: "startTime",
          type: "datetimerange",
          endPlaceholder: "结束时间",
          startPlaceholder: "开始时间",
          clearable: true,
        },
        {
          label: "商品品牌",
          key: "brandNo",
          type: "select",
          placeholder: "请选择商品品牌",
          clearable: true,
          optionList: brandlistData.value,
          isfilterable: 1,
        },
      ],
    });
    const isOne = ref<boolean>(false);
    // select点击
    const changeSelect = (val: any, key?: any) => {
      console.log(key + "+++++++++++++++++++++++++++++");
      console.log(val, "/////////////");
      if (val == "brandNo") {
        return;
      }
      if (key == 1 && val == "") {
        listSimpleArr2.value = [];
        listSimpleArr3.value = [];
        productForm.value.twoGoodTypeId = "";
        productForm.value.threeGoodTypeId = "";
      } else if (key == 2 && val == "") {
        listSimpleArr3.value = [];
        productForm.value.threeGoodTypeId = "";
      } else {
        if (key == 1) {
          productForm.value.twoGoodTypeId = "";
          productForm.value.threeGoodTypeId = "";
        } else if (key == 2) {
          productForm.value.threeGoodTypeId = "";
        }
        listSimpleForm.value.parentId = val;
        getMyClass(key);
      }

      // listSimpleForm.value.merchantId = val.merchantId;
    };

    const submitForm = (val?: any) => {
      // productForm.value.firstGoodTypeId = val.value.typeId;
      // productForm.value.twoGoodTypeId = val.value.twoGoodTypeId;
      // productForm.value.threeGoodTypeId = val.value.threeGoodTypeId;
      productForm.value.startTime = val.value.startTime && val.value.startTime.length ? moment(val.value.startTime[0]).valueOf() : "";
      productForm.value.endTime = val.value.startTime && val.value.startTime.length ? moment(val.value.startTime[1]).valueOf() : "";
      productForm.value.name = val.value.name;
      productForm.value.code = val.value.code;
      productForm.value.brandNo = val.value.brandNo;
      console.log(productForm.value);
      getProductTable();
    };

    const headerimg = ref("/compontsimg/spzk.png");
    // from 开关
    const FromData = ref();
    // 编辑分类
    const myclick = (row: any) => {
      FromData.value = row;
      console.log(FromData.value);
      router.push({ path: "/Commodityallocation/stock/details", query: { code: row.code } });
    };
    // 添加分类
    const addProduct = () => {
      FromData.value = {};
      router.push("/Commodityallocation/stock/details");
    };
    // 新增下级分类
    const addDownClass = (row: void) => {
      FromData.value = row;
      FromData.value.name = "";
    };
    // 推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: void) => {
      pushDisplay.value = true;
    };
    // 每页条数
    const handleSizeChange = (val: any) => {
      productForm.value.pageSize = val;
      getProductTable();
      console.log(val);
    };
    // 分页
    const handleCurrentChange = (val: any) => {
      productForm.value.pageNum = val;
      getProductTable();
      console.log(val);
    };

    const imgViewerVisible = ref(false);
    // 图片预览
    const imgurl = ref<string>("");
    const changeImg = (url: string) => {
      imgurl.value = url;
      imgViewerVisible.value = true;
    };
    const imageUrl = ref("");

    return {
      tableData,
      tableColumn,
      myclick,
      changeImg,
      imgurl,
      imgViewerVisible,
      imageUrl,
      addProduct,
      FromData,
      pushDisplay,
      switchFn,
      addDownClass,
      headerimg,
      state,
      changeSelect,
      submitForm,
      handleSizeChange,
      handleCurrentChange,
      productForm,
      listSimpleArr1,
      listSimpleArr2,
      listSimpleArr3,
    };
  },
});
